import { Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/Login'
import AdminLayout from './components/layout/AdminLayout'
import AuthGuard from './components/auth/AuthGuard'

// Modules will be imported here by Phase 3 agents
// IMPORT_MODULES_HERE
import Dashboard from './modules/Dashboard/Dashboard'
import Analytics from './modules/Analytics/Analytics'
import Team from './modules/Team/Team'
import Messages from './modules/Messages/Messages'
import Settings from './modules/Settings/Settings'
import Documents from './modules/Documents/Documents'
import Menus from './modules/Menus/Menus'
import News from './modules/News/News'
import ArticleEditor from './modules/News/ArticleEditor'
import Gallery from './modules/Gallery/Gallery'

function AppRouter() {
  return (
    <Routes>
      {/* Public route */}
      <Route path="/login" element={<Login />} />

      {/* Protected admin routes */}
      <Route
        path="/admin"
        element={
          <AuthGuard>
            <AdminLayout />
          </AuthGuard>
        }
      >
        {/* ROUTES_HERE - Phase 3 agents will add their routes */}
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="team" element={<Team />} />
        <Route path="news/new" element={<ArticleEditor />} />
        <Route path="news/:id/edit" element={<ArticleEditor />} />
        <Route path="news" element={<News />} />
        <Route path="messages" element={<Messages />} />
        <Route path="menus" element={<Menus />} />
        <Route path="documents" element={<Documents />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* Redirect root to admin */}
      <Route path="/" element={<Navigate to="/admin" replace />} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  )
}

export default AppRouter
